// extracted by mini-css-extract-plugin
export var statItem = "_hi-1";
export var statsRow = "_hi-0";